import styled from 'styled-components';
import { enumToPrimaryColorMap } from '../../../../../utils';
import { CategoryMarkerProps } from './types';

export const CategoryMarker = styled.div<CategoryMarkerProps>`
    ${({ theme, color, circle }) => `
        width: ${theme.spacing(1.25)}px;
        height: ${theme.spacing(1.25)}px;
        margin-right: ${theme.spacing(1)}px;
        border-radius: ${circle ? `100%` : `2px`};
        background-color: ${enumToPrimaryColorMap(theme, color)};
    `}
`;
